import * as THREE from "three";

const colorList = [
  {
    uColor1: "#003c70",
    uColor2: "#d88818",
    uColor3: "#32432d",
    uColor4: "#1a4107",
    uEnd1: 0.1,
    uEnd2: 0.2,
    uEnd3: 0.3,
  },
  {
    uColor1: "#752300",
    uColor2: "#3d1010",
    uColor3: "#2c2020",
    uColor4: "#0e0c0c",
    uEnd1: 0.3,
    uEnd2: 0.4,
    uEnd3: 0.5,
  },
  {
    uColor1: "#8ba9da",
    uColor2: "#ffffff",
    uColor3: "#696969",
    uColor4: "#bdc1ff",
    uEnd1: 0.2,
    uEnd2: 0.6,
    uEnd3: 0.7,
  },
  {
    uColor1: "#105a9c",
    uColor2: "#836e2a",
    uColor3: "#034f04",
    uColor4: "#055122",
    uEnd1: 0.3,
    uEnd2: 0.5,
    uEnd3: 0.7,
  },
  {
    uColor1: "#006dcc",
    uColor2: "#d1bc33",
    uColor3: "#474747",
    uColor4: "#004d1d",
    uEnd1: 0.70,
    uEnd2: 0.85,
    uEnd3: 0.90
  },
];
const actualColor = {};
let draggElement = null;
let world;

export default function createTextureUi(newWorld) {
  world = newWorld;
  const texture = document.getElementById("texture");

  // Create toggler
  const togglerBody = document.createElement("div");
  togglerBody.id = "togglerBody";

  // Color
  const colorToggle = document.createElement("div");
  colorToggle.id = "colorToggle";

  // Create parts
  for (let i = 0; i < 4; i++) {
    const panel = document.createElement("input");
    panel.type = "color";

    colorToggle.appendChild(panel);
  }

  // Heights
  const linesHolder = document.createElement("div");
  linesHolder.id = "linesHolder";

  for (let i = 0; i < 3; i++) {
    const line = document.createElement("div");

    linesHolder.appendChild(line);
  }

  texture.appendChild(togglerBody);
  togglerBody.appendChild(colorToggle);
  togglerBody.appendChild(linesHolder);

  setLineEvents();
  setColorEvents();
  populateColorList();
  setNewColor(colorList[0]);
  updateToggler();
}

function updateToggler() {
  // Colors
  const colorToggle = document.getElementById("colorToggle");
  const linesHolder = document.getElementById("linesHolder");

  // 0
  const child0 = colorToggle.children[0];
  const end1 = 100 - actualColor.uEnd1 * 100;
  child0.value = actualColor["uColor1"];
  child0.style.clipPath = `polygon(0 ${end1}%, 100% ${end1}%, 100% 100%, 0% 100%)`;

  // 1
  const child1 = colorToggle.children[1];
  const end2 = 100 - actualColor.uEnd2 * 100;
  child1.value = actualColor["uColor2"];
  child1.style.clipPath = `polygon(0 ${end2}%, 100% ${end2}%, 100% ${end1}%, 0% ${end1}%)`;

  const line1 = linesHolder.children[0];
  line1.style.clipPath = `polygon(25% ${end1 + 2.5}%, 100% ${
    end1 + 2.5
  }%, 100% ${end1 - 2.5}%, 25% ${end1 - 2.5}%, 0% ${end1}%)`;

  // 2
  const child2 = colorToggle.children[2];
  const end3 = 100 - actualColor.uEnd3 * 100;
  child2.value = actualColor["uColor3"];
  child2.style.clipPath = `polygon(0 ${end3}%, 100% ${end3}%, 100% ${end2}%, 0% ${end2}%)`;

  const line2 = linesHolder.children[1];
  line2.style.clipPath = `polygon(25% ${end2 + 2.5}%, 100% ${
    end2 + 2.5
  }%, 100% ${end2 - 2.5}%, 25% ${end2 - 2.5}%, 0% ${end2}%)`;

  // 3
  const child3 = colorToggle.children[3];
  child3.value = actualColor["uColor4"];
  child3.style.clipPath = `polygon(0 0, 100% 0, 100% ${end3}%, 0% ${end3}%)`;

  const line3 = linesHolder.children[2];
  line3.style.clipPath = `polygon(25% ${end3 + 2.5}%, 100% ${
    end3 + 2.5
  }%, 100% ${end3 - 2.5}%, 25% ${end3 - 2.5}%, 0% ${end3}%)`;
}

function setLineEvents() {
  // Click
  const linesHolder = document.getElementById("linesHolder");
  linesHolder.children[0].addEventListener("mousedown", () => {
    dragLine1();
  });
  linesHolder.children[0].addEventListener("touchstart", () => {
    dragLine1();
  });

  linesHolder.children[1].addEventListener("mousedown", () => {
    dragLine2();
  });
  linesHolder.children[1].addEventListener("touchstart", () => {
    dragLine2();
  });

  linesHolder.children[2].addEventListener("mousedown", () => {
    dragLine3();
  });
  linesHolder.children[2].addEventListener("touchstart", () => {
    dragLine3();
  });

  // Drop
  document.addEventListener("mouseleave", () => {
    draggElement = null;
    document.body.style.userSelect = "";
  });
  document.addEventListener("mouseup", () => {
    draggElement = null;
    document.body.style.userSelect = "";
  });
  document.addEventListener("touchend", () => {
    draggElement = null;
    document.body.style.userSelect = "";
  });

  // Drag
  document.addEventListener("mousemove", (event) => {
    if (draggElement) {
      drag(linesHolder, event.clientY);
    }
  });
  document.addEventListener("touchmove", (event) => {
    if (draggElement) {
      drag(linesHolder, event.changedTouches[0].clientY);
    }
  });
}

// Drag Lines
function dragLine1() {
  document.body.style.userSelect = "none";
  draggElement = {
    value: "uEnd1",
    min: 0,
    max: actualColor["uEnd2"] - 0.05,
  };
}
function dragLine2() {
  document.body.style.userSelect = "none";
  draggElement = {
    value: "uEnd2",
    min: actualColor["uEnd1"] + 0.05,
    max: actualColor["uEnd3"] - 0.05,
  };
}
function dragLine3() {
  document.body.style.userSelect = "none";
  draggElement = {
    value: "uEnd3",
    min: actualColor["uEnd2"] + 0.05,
    max: 1,
  };
}

function drag(parent, y) {
  const box = parent.getBoundingClientRect();
  const localPosPixel = y - box.top;
  let ratio = 1 - localPosPixel / box.height;

  if (ratio < draggElement.min) {
    ratio = draggElement.min;
  } else if (ratio > draggElement.max) {
    ratio = draggElement.max;
  }
  actualColor[draggElement.value] = ratio;
  updateToggler();

  world.uniforms[draggElement.value].value = ratio;

  // Upate Water Height
  if (draggElement.value == "uEnd1") {
    world.refreshWater()
  }
}

function setColorEvents() {
  const colorToggle = document.getElementById("colorToggle");
  const colorsList = ["uColor1", "uColor2", "uColor3", "uColor4"];

  for (let i = 0; i < colorToggle.children.length; i++) {
    const input = colorToggle.children[i];

    input.addEventListener("input", () => {
      const newValue = input.value;

      actualColor[colorsList[i]] = newValue;
      world.uniforms[colorsList[i]].value = new THREE.Color(newValue);

      if(colorsList[i] == "uColor1"){
        world.refreshWater()
      }
    })
  }
}

function populateColorList() {
  const textureBody = document.getElementById("texture");
  const listHolder = document.createElement("div");
  listHolder.id = "listHolder";

  textureBody.appendChild(listHolder);

  for (let color of colorList) {
    const body = document.createElement("div");
    body.className = "colorHolder";

    body.addEventListener("click", () => {
      setNewColor(color);
    });

    listHolder.appendChild(body);

    for (let i = 0; i < 4; i++) {
      const color = document.createElement("div");

      body.appendChild(color);
    }

    // 0
    const child0 = body.children[0];
    const end1 = 100 - color.uEnd1 * 100;
    child0.style.backgroundColor = color["uColor1"];
    child0.style.clipPath = `polygon(0 ${end1}%, 100% ${end1}%, 100% 100%, 0% 100%)`;

    // 1
    const child1 = body.children[1];
    const end2 = 100 - color.uEnd2 * 100;
    child1.style.backgroundColor = color["uColor2"];
    child1.style.clipPath = `polygon(0 ${end2}%, 100% ${end2}%, 100% ${end1}%, 0% ${end1}%)`;

    // 2
    const child2 = body.children[2];
    const end3 = 100 - color.uEnd3 * 100;
    child2.style.backgroundColor = color["uColor3"];
    child2.style.clipPath = `polygon(0 ${end3}%, 100% ${end3}%, 100% ${end2}%, 0% ${end2}%)`;

    // 3
    const child3 = body.children[3];
    child3.style.backgroundColor = color["uColor4"];
    child3.style.clipPath = `polygon(0 0, 100% 0, 100% ${end3}%, 0% ${end3}%)`;
  }
}

function setNewColor(color) {
  for (let key in color) {
    actualColor[key] = color[key];

    if (key.includes("Color")) {
      world.uniforms[key].value = new THREE.Color(color[key]);
    } else {
      world.uniforms[key].value = color[key];
    }
  }

  world.refreshWater()
  updateToggler();
}
